module.exports = __webpack_public_path__ + "media/Pill-IconReplacement.cfb97a80.mp4";